
import '@wangeditor/editor/dist/css/style.css';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { uploadFile } from '@/api/open';
import { onBeforeUnmount, shallowRef, onMounted, defineComponent, computed } from 'vue';
import type { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import { ElMessage } from 'element-plus';

type InsertFnType = (url: string, poster: string) => void

export default defineComponent({
  components: {
    Editor, Toolbar,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const editorRef = shallowRef<IDomEditor>();

    const valueHtml = computed({
      get() {
        return props.modelValue;
      },
      set(val) {
        console.log(2323, val);
        emit('update:modelValue', val);
      },
    });

    const toolbarConfig: Partial<IToolbarConfig> = {
      excludeKeys: ['group-video', 'insertLink'],
    };
    const editorConfig: Partial<IEditorConfig> = {
      placeholder: '请输入内容...',
      MENU_CONF: {
        uploadImage: {
          async customUpload(file: File, insertFn: InsertFnType) {
            const image = file;
            if (!/^image/.test(image.type)) {
              ElMessage.warning('图片格式错误');
            } else {
              const formData = new FormData();
              formData.append('files', image, image.name);
              const { data } = await uploadFile(formData);
              const [imageItem] = data;
              insertFn(imageItem.url, file.name);
            }
          },
        },
      },
    };

    const handleCreated = (editor: IDomEditor) => {
      editorRef.value = editor;
      console.log(editorRef.value.getMenuConfig('uploadVideo'), editorRef.value.getConfig());
    };

    onMounted(() => {});
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });

    return {
      editorRef,
      valueHtml,
      mode: 'default',
      toolbarConfig,
      editorConfig,
      handleCreated,
    };
  },
});
